import { render, staticRenderFns } from "./defaultappslim.vue?vue&type=template&id=f6d9d140&"
import script from "./defaultappslim.vue?vue&type=script&lang=js&"
export * from "./defaultappslim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports